import { useNavigate } from "react-router-dom";
import BackButton from "../../components/BackButton";
import CalculationsTable from "../../components/CalculationsTable";
import HistoricalStdLogs from "../../components/HistoricalStdLogs";
import { useState, useEffect } from "react";
import { toast } from "sonner";
import api from "../../api/manage_calculations/JetsonReq";
import { useNotifications } from '../../context/NotificationsProvider';

const ManageCalculations = () => {

    const navigate = useNavigate();
    
    const [data, setData] = useState([]);
    const { notifications } = useNotifications();

    useEffect(() => {    
        const getCalculationPatternStdAll = async () => { 
            try {
                const response = await api.get(
                    'calculation-pattern-std-all',
                    {
                        withCredentials: true
                    }
                )
                if (response.data.success) {
                    const tempData = response.data.payload.map((record) => {
                        return {
                            flowMeterName: record.flow_meter_name,
                            base: record.base,
                            statePattern: record.process_state_pattern,
                            stateCurrent: record.process_state_historical,
                            datetimeFrom: record.datetime_from,
                            datetimeTo: record.datetime_to
                        }
                    })
                    setData(tempData);             
                } else {
                    setData([]);
                    toast.error(response.data.message);
                }
                
            } catch (err) {
                console.log(err.response);
            }
        }
        getCalculationPatternStdAll();
    }, [notifications])

    return (
        <div className="manage-calculations-new-container">
            <CalculationsTable
                data={data}
            />
            <HistoricalStdLogs />
            <div className='manage-calculations-new-card'>
                <h2 className='manage-calculations-new-title'>Manage</h2>
                <h2 className='manage-calculations-new-title'>Calculations</h2>
                <button className='manage-calculations-new-button' onClick={() => navigate('std-pattern')}>
                    Std Pattern
                </button>
                <button className='manage-calculations-new-button' onClick={() => navigate('std-historical')}>
                    Std Historical
                </button>
                <button className='manage-calculations-new-button'>
                    Another...
                </button>
            </div>
            <BackButton navigateTo='/menu'/> 
        </div>
    );
};

export default ManageCalculations;
